export const ReviewIcon = () => (
	<svg
		width="24"
		height="24"
		viewBox="-2 -2 28 28"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="m7 12.3 3-1.8 3 1.8-.8-3.4 2.6-2.2-3.5-.3L10 3.2 8.7 6.5l-3.4.3 2.5 2.2-.7 3.3ZM0 20V2C0 1.4.2 1 .6.6A2 2 0 0 1 2 0h16c.6 0 1 .2 1.4.6.4.4.6.8.6 1.4v12c0 .6-.2 1-.6 1.4a2 2 0 0 1-1.4.6H4l-4 4Zm3.1-6H18V2H2v13.1L3.1 14Z"
			fill="currentColor"
		/>
	</svg>
);
